<div class="flex flex-row flex-nowrap min-w-fit items-center pr-4 gap-2 h-full">
  @if (icon(); as icon) {
    <soft-icon [name]="icon" class="mx-2 scale-150"></soft-icon>
  }
  <div class="flex flex-col">
    <div class="text-sm font-semibold">{{ title() | translate }}</div>
    @if (readonly()) {
      <div class="text-xs">
        {{ option()?.label ?? 'auswählen...' }}
      </div>
    } @else {
      <div class="soft-link text-xs" (click)="onClick()">
        {{ option()?.label ?? 'auswählen...' }}
      </div>
    }
  </div>
</div>
